import type { AlienScenarioDefinition } from './types';

export const alienInvasionScenarios: AlienScenarioDefinition[] = [
  {
    "id": "invasion",
    "title": "Invasion",
    "playerCount": "3–5",
    "mode": "1 vs 2–4",
    "difficulty": "umiarkowany",
    "contentStatus": "draft-from-preview-v28",
    "sourceWarning": "Treść z Preview v28 — WORK IN PROGRESS — NOT FINAL.",
    "sectionIds": [
      "ai:invasion:overview",
      "ai:invasion:components",
      "ai:invasion:setup-humans",
      "ai:invasion:setup-aliens",
      "ai:invasion:victory",
      "ai:invasion:turn-order",
      "ai:invasion:human-tech",
      "ai:invasion:human-scoring",
      "ai:invasion:building-restrictions",
      "ai:invasion:executive-cost",
      "ai:invasion:defensive-blueprints",
      "ai:invasion:alien-turn",
      "ai:invasion:unlock",
      "ai:invasion:perform-actions",
      "ai:invasion:alien-actions",
      "ai:invasion:alien-blueprints",
      "ai:invasion:alien-scientist",
      "ai:invasion:troopers",
      "ai:invasion:reset"
    ]
  },
  {
    "id": "outbreak",
    "title": "Outbreak",
    "playerCount": "2–4",
    "mode": "kooperacja",
    "difficulty": "trudny",
    "contentStatus": "draft-from-preview-v28",
    "sourceWarning": "Treść z Preview v28 — WORK IN PROGRESS — NOT FINAL.",
    "sectionIds": [
      "ai:outbreak:overview",
      "ai:outbreak:components",
      "ai:outbreak:setup",
      "ai:outbreak:victory",
      "ai:outbreak:infection-draw",
      "ai:outbreak:infected-colonists",
      "ai:outbreak:medicine",
      "ai:outbreak:hospitals",
      "ai:outbreak:advanced-buildings",
      "ai:outbreak:end-turn",
      "ai:outbreak:shuttle",
      "ai:outbreak:missions"
    ]
  },
  {
    "id": "blackout",
    "title": "Blackout",
    "playerCount": "2–4",
    "mode": "kooperacja",
    "difficulty": "umiarkowany",
    "contentStatus": "draft-from-preview-v28",
    "sourceWarning": "Treść z Preview v28 — WORK IN PROGRESS — NOT FINAL.",
    "sectionIds": [
      "ai:blackout:overview",
      "ai:blackout:components",
      "ai:blackout:setup",
      "ai:blackout:victory",
      "ai:blackout:vandalism",
      "ai:blackout:building-states",
      "ai:blackout:repair"
    ]
  },
  {
    "id": "monolith",
    "title": "Monolith",
    "playerCount": "1",
    "mode": "solo",
    "difficulty": "konfigurowalny",
    "contentStatus": "draft-from-preview-v28",
    "sourceWarning": "Treść z Preview v28 — WORK IN PROGRESS — NOT FINAL.",
    "sectionIds": [
      "ai:monolith:overview",
      "ai:monolith:components",
      "ai:monolith:setup",
      "ai:monolith:goals",
      "ai:monolith:victory",
      "ai:monolith:sabotage-phase",
      "ai:monolith:scoring"
    ]
  }
];
